module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_2.24b93321.pdf";